var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"countdown"},[_c('vue-countdown',{key:_vm.keyTimer,ref:"countdown",attrs:{"time":+_vm.msLocal,"transform":_vm.transformSlotProps},on:{"progress":_vm.progressHandler},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var minutes = ref.minutes;
var seconds = ref.seconds;
return [_vm._v(" "+_vm._s(minutes)+":"+_vm._s(seconds)+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }